export default "__VITE_ASSET__b8a3cf2b__"